import { IStaticOptimalProduction } from "@/features/roi_overview/useROIOverview.types";

export const optimalProduction: IStaticOptimalProduction[] = [
	{
		ticker: "RIG",
		amount: 35,
		sto: 1,
		total_area: 475.0,
		HB1: 11.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "TNP",
		amount: 11,
		sto: 1,
		total_area: 471.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 9.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "PP1",
		amount: 16,
		sto: 1,
		total_area: 449.0,
		HB1: 13.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "CLF",
		amount: 10,
		sto: 1,
		total_area: 433.0,
		HB1: 0.0,
		HB2: 4.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "FP",
		amount: 28,
		sto: 1,
		total_area: 471.0,
		HB1: 12.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "FS",
		amount: 14,
		sto: 2,
		total_area: 464.0,
		HB1: 0.0,
		HB2: 7.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "FRM",
		amount: 13,
		sto: 1,
		total_area: 475.0,
		HB1: 7.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "WEL",
		amount: 17,
		sto: 2,
		total_area: 473.0,
		HB1: 12.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "BMP",
		amount: 20,
		sto: 1,
		total_area: 455.0,
		HB1: 20.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "PP3",
		amount: 11,
		sto: 1,
		total_area: 464.0,
		HB1: 0.0,
		HB2: 2.0,
		HB3: 4.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "ELP",
		amount: 11,
		sto: 1,
		total_area: 473.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 4.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "APF",
		amount: 8,
		sto: 1,
		total_area: 437.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 5.0,
		HB4: 2.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "CLR",
		amount: 14,
		sto: 1,
		total_area: 474.0,
		HB1: 0.0,
		HB2: 3.0,
		HB3: 2.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "AAF",
		amount: 7,
		sto: 1,
		total_area: 449.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 3.0,
		HB5: 2.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "WPL",
		amount: 9,
		sto: 1,
		total_area: 459.0,
		HB1: 0.0,
		HB2: 7.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "INC",
		amount: 32,
		sto: 1,
		total_area: 465.0,
		HB1: 13.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "EXT",
		amount: 14,
		sto: 1,
		total_area: 459.0,
		HB1: 8.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 1.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "LAB",
		amount: 12,
		sto: 1,
		total_area: 468.0,
		HB1: 0.0,
		HB2: 2.0,
		HB3: 8.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "ASM",
		amount: 10,
		sto: 1,
		total_area: 457.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 5.0,
		HB4: 2.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "ECA",
		amount: 11,
		sto: 1,
		total_area: 471.0,
		HB1: 0.0,
		HB2: 1.0,
		HB3: 2.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 1.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SKF",
		amount: 9,
		sto: 3,
		total_area: 467.0,
		HB1: 0.0,
		HB2: 4.0,
		HB3: 1.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SME",
		amount: 20,
		sto: 2,
		total_area: 470.0,
		HB1: 10.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "PPF",
		amount: 20,
		sto: 1,
		total_area: 455.0,
		HB1: 0.0,
		HB2: 10.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "HYF",
		amount: 21,
		sto: 1,
		total_area: 472.0,
		HB1: 8.0,
		HB2: 4.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 1.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "POL",
		amount: 24,
		sto: 1,
		total_area: 473.0,
		HB1: 1.0,
		HB2: 5.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 2.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "HWP",
		amount: 14,
		sto: 2,
		total_area: 471.0,
		HB1: 0.0,
		HB2: 5.0,
		HB3: 1.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SL",
		amount: 20,
		sto: 0,
		total_area: 472.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 4.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SD",
		amount: 17,
		sto: 0,
		total_area: 466.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 9.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "ORC",
		amount: 3,
		sto: 1,
		total_area: 425.0,
		HB1: 0.0,
		HB2: 3.0,
		HB3: 1.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "PP2",
		amount: 15,
		sto: 1,
		total_area: 470.0,
		HB1: 3.0,
		HB2: 3.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 1.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "REF",
		amount: 13,
		sto: 1,
		total_area: 456.0,
		HB1: 8.0,
		HB2: 3.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "MCA",
		amount: 11,
		sto: 1,
		total_area: 471.0,
		HB1: 0.0,
		HB2: 1.0,
		HB3: 2.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 1.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "PP4",
		amount: 9,
		sto: 1,
		total_area: 469.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 3.0,
		HB4: 2.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 1.0,
		HBL: 0.0,
	},
	{
		ticker: "CHP",
		amount: 17,
		sto: 1,
		total_area: 475.0,
		HB1: 0.0,
		HB2: 7.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 5.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SPP",
		amount: 6,
		sto: 1,
		total_area: 449.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 3.0,
		HB4: 2.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "PHF",
		amount: 11,
		sto: 1,
		total_area: 469.0,
		HB1: 0.0,
		HB2: 2.0,
		HB3: 2.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 1.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "UPF",
		amount: 7,
		sto: 2,
		total_area: 440.0,
		HB1: 1.0,
		HB2: 3.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 1.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SPF",
		amount: 8,
		sto: 2,
		total_area: 450.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 4.0,
		HB5: 2.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "EDM",
		amount: 12,
		sto: 1,
		total_area: 447.0,
		HB1: 0.0,
		HB2: 6.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "IVP",
		amount: 10,
		sto: 1,
		total_area: 433.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 7.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "EEP",
		amount: 4,
		sto: 0,
		total_area: 472.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 2.0,
		HB5: 1.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 1.0,
	},
	{
		ticker: "GF",
		amount: 12,
		sto: 1,
		total_area: 459.0,
		HB1: 0.0,
		HB2: 10.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SCA",
		amount: 11,
		sto: 1,
		total_area: 456.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 4.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "SE",
		amount: 18,
		sto: 0,
		total_area: 456.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 6.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "FER",
		amount: 14,
		sto: 1,
		total_area: 475.0,
		HB1: 0.0,
		HB2: 8.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 1.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "AML",
		amount: 8,
		sto: 1,
		total_area: 451.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 2.0,
		HB4: 3.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "DRS",
		amount: 11,
		sto: 1,
		total_area: 463.0,
		HB1: 0.0,
		HB2: 0.0,
		HB3: 5.0,
		HB4: 3.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
	{
		ticker: "COL",
		amount: 22,
		sto: 1,
		total_area: 455.0,
		HB1: 11.0,
		HB2: 0.0,
		HB3: 0.0,
		HB4: 0.0,
		HB5: 0.0,
		HBB: 0.0,
		HBC: 0.0,
		HBM: 0.0,
		HBL: 0.0,
	},
];
